import { render, staticRenderFns } from "./central.vue?vue&type=template&id=c4781ad2&scoped=true&"
import script from "./central.vue?vue&type=script&lang=js&"
export * from "./central.vue?vue&type=script&lang=js&"
import style0 from "./central.vue?vue&type=style&index=0&id=c4781ad2&scoped=true&lang=less&"
import style1 from "./central.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4781ad2",
  null
  
)

export default component.exports